<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    html body {
        width: 100vw;
        margin: 0;
        padding: 0;
    }

    #app {
        color: #2c3e50;
    }

    .mint-msgbox-message {
        width: 4rem;
        line-height: 0.8rem;
        margin: 0 auto;
        font-size: 0.6rem;
        color: red;
    }

    .mint-msgbox-btns {
        height: 1rem;
        font-size: 0.4rem;
    }

    .mint-msgbox-header {
        padding: 0.2rem 0 0.2rem;
    }

    .mint-msgbox-title {
        font-size: 0.6rem;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue